import React from 'react';
import AvastFooter from "./AvastFooter";

const Footer = ({extraStyle}) => {
    return (<AvastFooter extraStyle={extraStyle}/>)
};

export default Footer;
